// extracted by mini-css-extract-plugin
export default {"title":"Intro_title__r4kpg","richtext":"Intro_richtext__qPLHp"};